import React from 'react';
import Button from 'app/components/button';
const FilterModel = ({
  isFilterOpen,
  setIsFilterOpen,
  resetfilter,
  onSubmit,
  onCancel,
  children,
  filter = true,
  heading = 'Filter',
  onHideFilter = null,
  // Submit button text. The voucher side panel inside the package form submits with
  // 'Add to package' or 'Save', and the package collect panel with its own label.
  // This renders a <form>: mount it as a page-level sibling, never inside another
  // <form>, and have onSubmit call event.preventDefault() and check validity first
  // (see CollectionPanel/CollectVoucher.js).
  submitLabel = 'Submit',
}) => {
  return (
    <div className={`offcanvas-modal ${isFilterOpen ? 'open' : ''}`}>
      <div className='offcanvas-modal-content'>
        <div className='offcanvas-modal-header'>
          {heading && <h4>{heading}</h4>}
          <button
            className='close-button'
            onClick={() => {
              setIsFilterOpen(false);
              onHideFilter && onHideFilter();
            }}
          >
            ×
          </button>
        </div>
        <form className='offcanvas-modal-body' onSubmit={onSubmit}>
          {children}

          <div className='offcanvas-actions'>
            <Button
              className='mt1'
              onClick={() => {}}
              variant='Save'
              name={submitLabel}
            />
            {filter && (
              <Button
                type='button'
                className='mt-1 cancel-button'
                onClick={resetfilter}
                variant='Cancel'
                name='Reset'
              />
            )}

            <Button
              type='button'
              className='mt-1 cancel-button'
              onClick={onCancel}
              variant='Cancel'
              name='Cancel'
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default FilterModel;
